import { isGoogleSignup } from '../../app/verificationTypeSelectors';
import { getIsActiveAndAssignedToVariantAcq136 } from '../../experiments/acq136/acq136Selectors';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { Step } from '../../views/Step';
export const BranchACQ136 = {
  name: 'BranchACQ136',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariantAcq136(state) && isGoogleSignup(state);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const nextSteps = dispatch(FlowStateManager.replaceStep(Step.CrmExperienceLevel, Step.GoogleContactsSync, Step.CrmExperienceLevel));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.Industry,
  afterData: null,
  afterStep: null
};